function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n\n  height: 42px;\n  border-radius: 8px;\n  width: 315px;\n\n  input {\n    color: #5ac132;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n\n    width: 100%;\n    height: 100%;\n    padding: 2px 12px;\n    background: #fff;\n    border: unset;\n    &:hover,\n    &:focus {\n      outline: unset;\n    }\n  }\n  & > button {\n    border-radius: 0px 8px 8px 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Button } from "../../Button";
var WrapStyledInput = styled.div.withConfig({
    componentId: "sc-1de77f35-0"
})(_templateObject());
var SocialLinks = function(_param) /*#__PURE__*/ {
    var props = _extends({}, _param);
    return _jsxs(WrapStyledInput, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ _jsx("input", {
                placeholder: "Enter your email address"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "primary",
                children: /*#__PURE__*/ _jsx("svg", {
                    width: "18",
                    height: "16",
                    viewBox: "0 0 18 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M1 8H17M17 8L10 1M17 8L10 15",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    }));
};
export default /*#__PURE__*/ React.memo(SocialLinks, function() {
    return true;
});
